// Polyfills
import 'es6-object-assign/auto';
import 'core-js/fn/array/includes';
import 'intl'; // For Safari 9

// For Safari 9
import entries from 'object.entries';
import values from 'object.values';

if (!Object.entries) {
    entries.shim();
    values.shim();
}

import React from 'react';
import ReactDOM from 'react-dom';

// import analytics from '../lib/analytics';
import enableSa from '../lib/sa'; // 神策统计
import init from '../lib/htInit'; // 核桃统计
// import {isTeacherMode} from '../lib/hetao-mode';
// import GUI from '../containers/gui.jsx';
import AppStateHOC from '../lib/app-state-hoc.jsx';
import BrowserModalComponent from '../components/browser-modal/browser-modal.jsx';
import supportedBrowser from '../lib/supported-browser';
// import {printLogo} from '../lib/log.js';
import {getZoomValue} from '../lib/hetao-mode';


import styles from './index.css';
// printLogo();

// Register "base" page view
// analytics.pageview('/');
window.startLoadPageTime = (new Date()).getTime()
enableSa();
init();
const appTarget = document.createElement('div');
appTarget.className = styles.app;
document.body.appendChild(appTarget);
if (getZoomValue()) {
    document.body.style.zoom = getZoomValue();
}

if (supportedBrowser()) {
    // require needed here to avoid importing unsupported browser-crashing code
    // at the top level
    require('./render-gui.jsx').default(appTarget);

} else {
    BrowserModalComponent.setAppElement(appTarget);
    const WrappedBrowserModalComponent = AppStateHOC(BrowserModalComponent, true /* localesOnly */);
    const handleBack = () => {};
    // eslint-disable-next-line react/jsx-no-bind
    ReactDOM.render(<WrappedBrowserModalComponent onBack={handleBack} />, appTarget);
}
